import { FC, ReactElement } from 'react';
import { IWebhookRequestParam, IWebhookRequestParamValidation } from '../../../../types/webhooks';
import WebhookParameter from '../../components/WebhookParameter/WebhookParameter';
import Text, { TEXT } from '~/view/components/Text/Text';
import AddButton from '~/view/components/Controls/AddButton/AddButton';
import './style.scss';

interface IProps {
  title: string;
  params: IWebhookRequestParam[];
  paramsValidation: IWebhookRequestParamValidation[];
  addParam: () => void;
  deleteParam: (id: number) => void;
  editParam: (param: IWebhookRequestParam) => void;
}

const WebhookParameters: FC<IProps> = ({ title, params, paramsValidation, ...props }: IProps): ReactElement => {
  return (
    <div className="webhook-parameters">
      <Text type={TEXT.SECTION_HEADER} text={title} />

      {params.length ? (
        <div className="webhook-parameters__container">
          <div className="d-flex flex-row gap-15">
            <Text type={TEXT.BLOCK_HEADER} text="key" required className="webhook-parameters__column" />
            <Text type={TEXT.BLOCK_HEADER} text="Value" required className="webhook-parameters__column" />
          </div>

          <ul className="webhook-parameters__list">
            {params.map((param) => (
              <WebhookParameter
                key={param.id || param.frontId}
                param={param}
                validation={paramsValidation.find((validation) => validation.id === param.frontId)}
                deleteParam={props.deleteParam}
                editParam={props.editParam}
              />
            ))}
          </ul>
        </div>
      ) : null}

      <AddButton title="create_new" onAdd={props.addParam} className="align-self-center" />
    </div>
  );
};

export default WebhookParameters;
